import { useTableStore } from '@/store/table/useTableStore'

export function clearFilterMiddleware(to) {
  const store = useTableStore()
  // clear only change registry
  if (to.name === 'detailEvent') return
  store.clear()
}
